import React from 'react'
import Navigation from '../SubComponents/Navigation'
import { Outlet } from 'react-router-dom'
import Footer from '../SubComponents/Footer'
import ScrollBtn from '../SubComponents/ScrollBtn'

export default function HomeLayout() {
  return (
    <>
      <Navigation/>
      <Outlet/>
      <Footer/>
      <ScrollBtn/>
    </>
  )
}
